/*
 * @Author: tuzhijing tuzhijing@wiz.top
 * @Date: 2024-01-22 14:08:49
 * @LastEditors: tuzhijing tuzhijing@wiz.top
 * @LastEditTime: 2024-01-25 11:25:22
 * @FilePath: \wiz-3d-visualization\src\modules\visualization-cockpit\components\business\twoVote\config.js
 * @Description:
 */

/**
 * @description 金属BIM childe
 * @param {Array} tableHead
 * @param {string} api
 */
export const operationConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '操作票类型', prop: 'type' }, // 父组件赋值
      { label: '操作任务', prop: 'operateTask', },
      { label: '操作人', prop: 'operate' },
    ],
    api: '/api/wfmodule/ticketCurrent/getTicketCurrentList',
  },
}

export const DangerConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '作业票类型', prop: 'handleType' }, // 父组件赋值
      { label: '地点及设备', prop: 'addressEquipment' },
      { label: '工作内容', prop: 'workContent' },
    ],
  },
}

export const workConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '工作票类型', prop: 'workTicketType' }, // 父组件赋值
      { label: '工作内容', prop: 'workContent', },
      { label: '地点及设备', prop: 'addressEquipment' },
    ],
    api: '/api/wfmodule/workTickets/getWorkTicketList',
  },
}

export const detailsConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '工作票状态', prop: 'fromState', width: 130 }, // 父组件赋值
      { label: '工作票号', prop: 'ticketId', width: 130 },
      { label: '设备编码', prop: 'deviceIdentifier', width: 130 },
      { label: '设备名称', prop: 'deviceName', width: 160 },
      { label: '工作内容', prop: 'operationModeName', width: 160 },
    ],
    api: '/api/wfmodule/ticketCurrent/getTicketCurrent',
  },
}
